const serviceUrl = `${__configuration.apiUrl}/massia/images`;

export default class ImagesService {
    static $inject = ['$http', 'TypesNiveauxHierarchique', 'Upload', 'notification', '$translate'];

    constructor($http, TypesNiveauxHierarchique, Upload, notification, $translate) {
        this.$http = $http;
        this.TypesNiveauxHierarchique = TypesNiveauxHierarchique;
        this.Upload = Upload;
        this.notification = notification;
        this.$translate = $translate;
    }

    async getImages(filters, sorts, pagination) {
        const res = await this.$http.get(serviceUrl, {
            params: {
                filters: JSON.stringify(filters || []),
                sorts: JSON.stringify(sorts || []),
                pagination: JSON.stringify(pagination || {})
            }
        });

        return res.data;
    }

    /*async getImagesDownload(id, domaine) {
         let url = `${serviceUrl}/${id}/upload/${domaine}`;
         let res = await this.$http.get(url);
         return res.data;
     }*/

    async deleteImageById(id) {
        const url = `${serviceUrl}/${id}`;
        return this.$http.delete(url);
    }

    async getImageEnteteById(id) {
        const url = `${serviceUrl}/${id}/entete`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async getImageValeursCaracteristiquesAssociationsById(id) {
        const data = await this.getImageValeursCaracteristiquesById(id);
        const result = {};

        for (const element in data) {
            if (data[element] && !Array.isArray(data[element])) {
                if (data[element].value === 'True') {
                    data[element].value = 'true';
                }
                if (data[element].value === 'False') {
                    data[element].value = 'false';
                }

                if (data[element].value && data[element].value.key) {
                    result[data[element].id] = data[element].value.key;
                } else {
                    result[data[element].id] = data[element].value;
                }
            }
        }
        return result;
    }

    async getImageValeursCaracteristiquesById(id) {
        const url = `${serviceUrl}/${id}/valeurs-caracteristiques`;
        const res = await this.$http.get(url);
        const result = [];
        res.data.forEach(function (element) {
            const caract = {
                id: element.id,
                code: element.code,
                idNature: element.idNature,
                indice: element.indice,
                label: element.label,
                numericAdditionalInformation: element.numericAdditionalInformation,
                value: element.elementsValues || element.elementValue || element.values || element.value
            };
            result.push(caract);
        });
        return result;
    }

    async createImage(image) {
        const data = {
            code: image.entete.code,
            libelle: image.entete.libelle,
            idType: image.entete.idType,
            source: image.entete.source,
            taille: image.entete.taille,
            caracteristiques: []
        };
        data.caracteristiques = this.formatCaracteristiques(image.caracteristiques);

        const result = await this.$http.post(serviceUrl, data);

        return result.data;
    }

    async createSignature(image) {
        const result = await this.$http.post(serviceUrl, image);
        return result.data;
    }

    async getIdTypeSignature() {
        const url = `${serviceUrl}/typeSignatureId`;
        const result = await this.$http.get(url);
        return result.data;
    }

    async getIdTypeLogo() {
        const url = `${serviceUrl}/typeLogoId`;
        const result = await this.$http.get(url);
        return result.data;
    }

    async createLogo(image) {
        const result = await this.$http.post(serviceUrl, image);
        return result.data;
    }

    formatCaracteristiques(caracteristiques) {
        const data = [];
        for (const property in caracteristiques) {
            let keyValueObject;
            //On vérifie que la propriété ne commence par pas '$' qui est normalement réservé aux variables interne Js.
            if (property[0] !== '$' && property !== 'data' && !isNaN(property)) {
                const propertyVal = caracteristiques[property];
                if (Array.isArray(propertyVal)) {
                    if (_.some(propertyVal, 'key')) {
                        keyValueObject = {
                            IdCaracteristique: parseInt(property),
                            valeurs: _.map(propertyVal, 'key')
                        };
                    } else {
                        keyValueObject = {
                            IdCaracteristique: parseInt(property),
                            valeurs: propertyVal
                        };
                    }
                } else {
                    keyValueObject = {
                        IdCaracteristique: parseInt(property),
                        valeur: propertyVal
                    };
                }
                data.push(keyValueObject);
            }
        }
        return data;
    }

    async updateImage(image) {
        const data = image.entete;
        data.caracteristiques = [];

        data.caracteristiques = this.formatCaracteristiques(image.caracteristiques);

        const url = `${serviceUrl}/${image.id}`;
        return await this.$http.put(url, data);
    }

    async codeExists(code) {
        const url = `${serviceUrl}/code-unicity/${code}`;
        const result = await this.$http.get(url);
        return result.data;
    }

    async onFileSelect($files, id, code) {
        const apiUrl = `${serviceUrl}/${id}/upload/${code}`; ///0
        const that = this;
        for (let i = 0; i < $files.length; i++) {
            const file = $files[i];
            this.upload = await this.Upload.upload({
                url: apiUrl,
                method: 'POST',
                file: file
            })
                .success(function (data) {
                    //logSuccess(data);
                    that.notification.success(that.$translate.instant('IMAGES.IMAGE_CHARGEE_SUCESS'));
                })
                .error(function (data, status) {
                    //logError('Failed to send file ' + status);
                    that.notification.error(that.$translate.instant('IMAGES.IMAGE_CHARGEE_ERROR'));
                });
        }
        return true;
    }

    async print(fileName, extension, code) {
        const url = `${__configuration.apiUrl}/massia/image/print/${fileName}/${extension}/${code}`;
        const res = await this.$http.get(url, {
            responseType: 'arraybuffer'
        });

        return res;
    }

    async getShowImage(fileName, extension, code) {
        const buff = await this.print(fileName, extension, code);
        let binary = '';
        const bytes = new Uint8Array(buff.data);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        const base64 = window.btoa(binary);
        return 'data:image/' + extension + ';base64,' + base64;
    }

    async getShowImageById(idImage) {
        const imageBDD = await this.getImageEnteteById(idImage);
        return await this.getShowImage(imageBDD.fileName, imageBDD.extension, imageBDD.code);
    }

    async getFiltres() {
        const url = `${serviceUrl}/headers`;
        const res = await this.$http.get(url);
        return res.data;
    }

    // async updateFiltre(id, domaine, idImages) {
    //     let data = {
    //         id: id,
    //         domaine: domaine,
    //         idImages: idImages
    //     };
    //     let url = `${__configuration.apiUrl}/massia/image/print`;
    //     return this.$http.put(url, data);
    // }
}
